import common from "./common.json";
import marketing from "./marketing.json";
import auth from "./auth.json";
import app from "./app.json";
import wizard from "./wizard.json";
import billing from "./billing.json";
import assetDetail from "./assetDetail.json";
import creativeSpace from "./creativeSpace.json";
import customerReview from "./customerReview.json";
import admin from "./admin.json";

export default {
  common,
  marketing,
  auth,
  app,
  wizard,
  billing,
  assetDetail,
  creativeSpace,
  customerReview,
  admin,
};
